import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { SearchBookmarkDto } from './search-bookmark-dto.type';

const SearchBookmarkDtoPaginationResponse = t.type(
  {
    pageIndex: t.number,
    pageSize: t.number,
    orderBy: nullable(t.string),
    orderIsAscending: t.boolean,
    items: nullable(t.array(SearchBookmarkDto)),
    totalCount: t.number,
  },
  'SearchBookmarkDtoPaginationResponse',
);

type SearchBookmarkDtoPaginationResponse = t.TypeOf<
  typeof SearchBookmarkDtoPaginationResponse
>;
export { SearchBookmarkDtoPaginationResponse };
